export const API = process.env.VUE_APP_API;
//export const API = "http://localhost:1337";
